import React, { useState } from 'react'

import { XStack } from 'tamagui'

import { Link } from '@newComponents/Link'
import { IconWrapper } from '@newComponents/Icon/IconWrapper'
import ArrowRightIcon from '@newComponents/Icon/icons/ArrowRightIcon'

export const ExploreMoreLink = ({
  href,
  children,
  ...props
}: {
  href: string
  children: React.ReactNode
} & Record<string, unknown>) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <Link
      href={href}
      display='flex'
      gap='$2'
      alignItems='center'
      fontWeight='$6'
      color='$primaryColor'
      animation='medium'
      hoverStyle={{ textDecorationLine: 'none' }}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      {...props}
    >
      {children}

      <XStack animation='medium' x={isHovered ? 4 : 0}>
        <IconWrapper size='$4' color='$primaryColor'>
          <ArrowRightIcon />
        </IconWrapper>
      </XStack>
    </Link>
  )
}
